module.exports = __webpack_public_path__ + "img/img18.3874bd14.png";